<template>
	<!-- <div id="faq"> -->
		<div class="faq" id="faqs">
			<!-- <div class="vertical_lines">
				<div class="vl"></div>
				<div class="vl"></div>
				<div class="vl"></div>
				<div class="vl"></div>
			</div> -->
			<div class="faq_content container">
				<h1>FAQ</h1>
				<div class="accordion_wrapper">
					<div class="accordion">
						<div class="accordion" id="accordionFaq">
							<div
							class="accordion-item"
							v-for="item in accordionItems"
							:key="item.id"
							>
							<template v-if="item.header == 'Half-Season Plan FAQ’s'">
								<h3 class="sub_header">Half-Season Plan</h3>
							</template>
							<template v-else>
								<div>
									<h2 class="accordion-header">
										<button
										class="accordion-button collapsed"
										type="button"
										data-bs-toggle="collapse"
										:data-bs-target="`#${item.id}`"
										>

											<h3><span>{{ item.count }}</span> {{ item.header }}</h3>
										</button>
									</h2>

								<div
									:id="item.id"
									class="accordion-collapse collapse"
									:class="!item.collapse || 'show'"
									data-bs-parent="#accordionFaq"
									>
									<div class="accordion-body">
										<div v-if="item.header == 'How do I update the information on my Islanders Account Manager?'">
											<p>
												<a href="https://am.ticketmaster.com/newyorkislanders/invoice" target="_blank" >Click here</a> to log into your Islanders Account Manager.
												Please reach out to your Member Services Account Manager with any questions.
												<!-- If you are looking to opt-out of your membership, <a style="color: #fff !important; font-weight:bold;font-family: 'GeogrotesqueSharp-Md'"
												@click="OptoutActive = true" @click.prevent="(e) => $emit('optOutShow', 'show')"  href="#">click here</a> and we’ll process your request. -->
											</p>

										</div>
										<div v-if="item.header =='How do I opt-out of my membership?'" >
											<!-- {{item.header}} -->
											<p>
												Before you make this decision, connect with your Member Service Account Manager.
												We’d love to hear why you no longer wish to be a Season Ticket Member. To opt-out,
												<a style="color: #fff !important; font-weight:bold;font-family: 'GeogrotesqueSharp-Md'"
												@click="OptoutActive = true" @click.prevent="(e) => $emit('optOutShow', 'show')"  href="#">click here</a>
												on or before February 20,2023, and we’ll process your request.
											</p>
											<!-- “” -->
										</div>
										<div v-else-if="item.header =='How can I learn more about club seating and suites at UBS Arena?'" >
											<!-- {{item.header}} -->
											<p>
												<a style="color: #fff !important; font-weight:bold;font-family: 'GeogrotesqueSharp-Md'"
												@click="upgradeActive = true" @click.prevent="(e) => $emit('upgradeShow', 'show')"  href="#">Click here</a> for information on upgrading your seats. You can also speak to your Member Service Account Manager for more information.

											</p>
											<!-- “Click here for information on upgrading your seats. You can also speak to your Member
Service Account Manager for more information.” -->
										</div>

										<div v-else class="faq_text" v-html="$sanitize(item.body)"></div>
									</div>
								</div>
						</div>
							</template>

				</div>
			</div>
		</div>
	</div>
</div>
</div>

</template>

<script>

export default {
	name: "Faq",
	emit: ["optOutShow", "upgradeShow"],
	data() {
		return {
			benefitLink: "#benefits",
			pricingLink: "#account_summary",
			accordionItems : [

				{
					id: "one",
					count: "1",
					header: "When will I receive my tickets?",
					body: `a.	UBS Arena is a mobile ticket only venue. Season Ticket Members can access tickets through <a href="https://am.ticketmaster.com/newyorkislanders/#/" target="_blank"  style="color:white !important;" >Account Manager</a> or by logging into the UBS Arena app and selecting My Events.
					Tickets for the 2023-24 season will be available following the release of the 2023-24 season schedule.`,
				},
				{
					id: 'two',
					count: "2",
					header: "How do I access my season ticket invoice for the 2023-2024 Season? ",
					body: `Season Ticket Member invoices are available by visiting either Account Manager or by logging into the UBS Arena app and selecting Invoices.`,
				},
				{
					id: 'three',
					count: "3",
					header: "How can I learn more about club seating or suites at UBS Arena?  ",
					body: `To learn more about the Spotlight Club, UBS Club, Verizon Lounge, DIME Club, or the Hyundai Club at UBS Arena, please fill out the Join Us form on our page. You can also email <a href="mailto:premiumsales@ubsarena.com" style="color:white !important;" >premiumsales@ubsarena.com</a> or call <a href="tel:888-694-7537" style="color:white !important;" >888-694-7537</a>.`,

				},
				{
					id: 'four',
					count: "4",
					header: "How do I purchase a parking pass for the 2023-2024 season?",
					body: `Season parking will be available for purchase based on seat location and membership tenure on a first come, first served basis in Emerald or Belmont Park Garage parking. Details on this purchase opportunity will be communicated at a later date.`,
				}
				// {
				// 	id: "two",
				// 	count: "1",
				// 	header: "How can I learn more about club seating and suites at UBS Arena?",
				// 	body : "",
				// 	// body: "To learn more about the Pitchbook Suites, Spotlight Suites, Spotlight Club, UBS Club, Verizon Lounge, DIME Club, or the Hyundai Club at UBS Arena, please contact your Member Service Account Manager.",
				// },
				// {
				// 	id: "three",
				// 	count: "2",
				// 	header: "What benefits come with my membership?",
				// 	body: `We’re excited to offer a variety of benefits only available to Season Ticket Members. Scroll up to the 2023-24 Membership Benefits Section or contact your Member Services Account Manager to learn more.  `,
				// },
				// {
				// 	id: "four",
				// 	count: "3",
				// 	header: 'Are my benefits per seat or per account?',
				// 	body: `Next season we’re excited to provide benefits per each seat on your account.`
				// },
				// {
				// 	id: "five",
				// 	count: "4",
				// 	header: "How do I purchase parking?",
				// 	body: `Season parking will be available for purchase based on seat location and membership tenure on a first come, first served basis in the Emerald Lot or the Belmont Park Garage.  Details on this opportunity will be communicated at a later date`,
				// },
				// {
				// 	id: "six",
				// 	count: "5",
				// 	header: "When will I be able to access tickets to my account?",
				// 	body: `UBS Arena is a mobile only venue.  You can access tickets through your <a href="https://am.ticketmaster.com/newyorkislanders/invoice" target="_blank"  style="color:white !important;" >Islanders Account Manager</a> or by logging into the UBS Arena app and selecting My Events. Tickets for the 2023-24 season will be available following the release of the 2023-24 season schedule.`,
				// },
				// {
				// 	id: "seven",
				// 	count: "7",
				// 	header: "How do I change my seating location for next season?",
				// 	body: `Let your Member Services Account Manager know you want to explore new locations.  Following our renewal deadline, members will have the ability look at new locations available before the general public.`,
				// },
				// {
				// 	id: "sixteen",
				// 	count: "8",
				// 	header: "How do I update the information on my Islanders Account Manager?",
				// 	body: "",
				// },
				// {
				// 	id: "eight",
				// 	count: "9",
				// 	header: "Can I add or drop seats?",
				// 	body: `Yes.  Connect with your Member Services Account Manager for more information.`,
				// },
				// {
				// 	id: "nine",
				// 	count: "9",
				// 	header: "What are my payment plan options?",
				// 	body: `We’re excited to provide maximum flexibility next season. <a href="https://am.ticketmaster.com/newyorkislanders/invoice" target="_blank" >Click here</a> to log into your Islanders Account Manager to update your payment plan and method of payment.
				// 	You can choose between 12, 6, 4, or 2 payment installments, with the first payment for all plans being charged on February 15, 2023.`,
				// },
				// {
				// 	id: "ten",
				// 	count: "6",
				// 	header: "What forms of payment are accepted?",
				// 	body: `We accept credit cards, wire transfers, and certified checks.  Contact your Member Services Account Manager with questions.  `,
				// },
				// {
				// 	id: "eleven",
				// 	count: "11",
				// 	header: "Where is my invoice?",
				// 	body: `Season Ticket Member invoices are available by visiting either <a href="https://am.ticketmaster.com/newyorkislanders/invoice" target="_blank" >Islanders Account Manager</a> or by logging into the UBS Arena app and selecting Invoices.`,
				// },
				// {
				// 	id: "twelve",
				// 	count: "13",
				// 	header: "How do I switch to a half season or quarter season plan?",
				// 	body: `Contact your Member Service Account Manager to learn about other plans and when they will be available.`,
				// },
				// {
				// 	id: "thirteen",
				// 	count: "7",
				// 	header: "What are my options for ADA Parking Accommodations? ",
				// 	body: `We have designated parking for guests with disabilities in all of our parking areas. Please note that all guests with disabilities who park in the accessible parking spots must have a valid disabled parking permit and/or plate on the vehicle. We encourage all guests to purchase parking in advance and arrive as early as possible. ADA accessible shuttles will run on a regular schedule while parking areas are open.
				// 	<br/><br/>
				// 	If you need further clarification on ADA accessibility at UBS Arena, please contact your Member Services Account Manager or <a href="https://ubsarena.com/accessibility-guide/" target="_blank">click here</a> for the UBS Arena Accessibility Guide.`,
				// },
				// {
				// 	id: "fourteen",
				// 	count: "13",
				// 	header: "How do I find my Member Pass to redeem benefits?",
				// 	body: `Log in to the UBS Arena app using the Islanders Ticketmaster account tied to the season ticket membership. Once logged in, at the top of the screen is a giftbox icon with MEMBER PASS written next to it. Click that icon and the personal member pass will appear.`,
				// },
				// {
				// 	id: "fifteen",
				// 	count: "14",
				// 	header: "How do I opt-out of my membership?",
				// 	body: "",
				// },

			],
		};
	},
	methods: {
		optOutHide(){
			this.OptoutActive  = false;
		},
	},
};
</script>

<style lang="scss" scoped>
a{
	color: #ffffff !important;
}
body{
	counter-reset: section;
}

.faq {

	.vertical_lines{
		position:absolute;
		top:-50px;
		right:200px;
		z-index:10;
		display:flex;
		padding-left:250px;
		@media only screen and (min-width: 578px) and (max-width: 900px)  {
			right:20px;
		}
		.vl{
			border-left: 40px solid  theme-var($--ch-theme-secondary);
			height: 107px;
			padding:14px;
			transform: skew(-20deg,0deg);
			@include media-breakpoint-down(sm) {
				&:nth-last-child(-n+2){
					display:none;
				}
			}
		}
		@include media-breakpoint-down(sm) {
			position: absolute;
			right:0px;
			padding-left: 0px;
		}
	}
	display: flex;
	position: relative;
	width:100%;
	background: url("~images/faq/bg-faq.jpg") no-repeat center;
	background-size: cover;
	@include media-breakpoint-down(sm) {
		overflow-x: clip;
	}
	&_content {
		padding:100px 150px;
		@include media-breakpoint-down(sm) {
			padding:50px 30px;
		}
		@media only screen and (min-width: 578px) and (max-width: 900px)  {
			padding:100px 30px;
		}
		z-index: 1;
		@include media-breakpoint-up(xl) {

		}
		h1 {
			font-family: "GeogrotesqueSharp-ExpBd";
			font-size: 100px;
			color: theme-var(--ch-theme-secondary);
			letter-spacing: 0;
			text-align: center;
			line-height: 100px;
			font-weight: 700;
			margin-bottom:30px;
			@include media-breakpoint-down(sm) {
				font-size: 70px;
			}
		}
		.sub_header{
			color: theme-var(--ch-theme-secondary);
			font-size: 30px;
			font-family: 'Verlag Condensed Black';
			text-transform:uppercase;
			margin: 30px 0px;
		}
		.accordion {
			width:100%;
			&_wrapper {
			}

			&-item {
				margin-bottom: 20px;
				border-radius: none;
				border:  none;
				background-color: transparent;
				&:last-of-type {
					border-radius: 0 !important;
					.accordion-collapse {
						border-radius: 0 !important;
					}
				}
				&:first-of-type {
					border-radius: 0 !important;
					.accordion-collapse {
						border-radius: 0 !important;
					}
				}
				// &:before {
				//   counter-increment: section ;
				//   content: "faq " counter(section) ": ";
				// }


			}
			&-body{
				background: #F16924;
				font-family: "GeogrotesqueSharp-Md";
				font-size: 16.5px;
				color: #FFFFFF;
				border: 2px solid #FFFFFF;
				border-top: none;
				letter-spacing: 0;
				font-weight: 500;
				line-height: 145%;
				padding: 15px 15px 10px 30px;
				counter-reset: section;
				@include media-breakpoint-down(sm) {
					font-size: 12px;
				}
				.faq_text{
					a{
						font-size: 13px;
						color: #FFFFFF !important;
					}
				}
			}

			h2{
				position:relative;
			}

			&-button {
				outline: none !important;
				background: #F16924;
				border: 2px solid #FFFFFF;
				border-radius: none;
				padding: 15px 15px 10px 30px;
				&:focus {
					border-color: none;
					box-shadow: none;
				}


				&::after {
					position:absolute;
					right:20px;
					top:0%;
					flex-shrink: 0;
					width: 1.25rem;
					height: 1.25rem;
					content: url("~images/arrow.svg");
					background-image: revert;
					transform: translate(0px ,50%);
					@include media-breakpoint-down(sm) {
						padding:0px 10px;
					}
				}


				&.collapsed {
					border: 2px solid #FFFFFF;

					&::after {
						transform: rotate(0deg);
						transition: transform 0.2s ease-in-out;
					}
				}
				&:not(collapsed) {
					border-bottom: none;
					h3 {
						color: white;
					}
					&::after {
						transform: rotate(-180deg);
						transition: transform 0.2s ease-in-out;
						position:absolute;
						top: 30%;

					}
				}

				h3 {
					color: theme-var($--ch-theme-on-primary);
					font-family: "GeogrotesqueSharp-Md";
					font-size: 15.5px;
					letter-spacing: 0;
					font-weight: 500;
					margin-right: 20px;
					text-transform:uppercase;
					display: flex;
					@include media-breakpoint-down(sm) {
						font-size: 12px;
						align-items:center;

					}

					span {
						font-family: "GeogrotesqueSharp-Bd";
						font-size: 17px;
						color: #FFFFFF;
						letter-spacing: 2px;
						text-align: center;
						font-weight: 700;
						margin-right:20px;
					}
				}
			}
		}
	}
}
</style>
